<template>
  <el-dialog :title="$t('purchasing.pay')" custom-class="MyDialog" :visible.sync="isDialogVisiblePay" :close-on-click-modal="false"
    @close="closeProcure2Pay" :width="$getColumnWidth(920, 990) + 'px'">
    <div>
      <div class="purchase-info">
        <div class="textOne">
          <span>{{ $t('purchasing.orderNo') }}：{{ payData.orderNo }}</span>
          <span>{{ $t('purchasing.orderTime') }}：{{ payData.orderCreateTime }}</span>
        </div>
        <div class="textTwo">
          <span>{{ $t('purchasing.purchaseQty') }}：{{ payData.buyNum }}{{ unitLabel }}</span>
          <span>{{ $t('purchasing.orderAmount') }}：<span :style="{ color: 'red' }">{{
            payData.orderAmount
          }}</span>
          <span v-if="showFreight">（{{ $t('purchasing.freightIncluded') }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ freightAmountDisplay }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}）</span>
        </span>
          <span>{{ $t('purchasing.paidAmount') }}：<span :style="{ color: 'red' }">{{
            isUsLocale ? $crmCurrencySymbol() : '' }}{{ payData.receivedAmount }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}
          </span></span>
        </div>
      </div>
      <div class="pay-box" :class="{ 'pay-box-en': $i18n.locale === 'en-US' }">
        <el-form label-position="left" :label-width="$getColumnWidth(130, 176) + 'px'" :model="formLabelAlign">
          <el-form-item v-if="isDoubleOrder" :label="$t('purchasing.relatedAgent') + '：'">
            <span>{{ dualCampusName }}</span>
          </el-form-item>
          <el-form-item :label="$t('purchasing.voucherBonusAccount') + '：'">
            <el-input v-model="formLabelAlign.voucherAccountPayMoney" @blur="countInputNum(1)"
              oninput="value=value.replace(/[^0-9.]/g,'')" :max="maxPayMoney" :disabled="true"></el-input>
            <span v-if="isDoubleOrder">{{ $t('purchasing.procurementAgentBalance') }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ procureVoucherAccount || 0 }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}</span>
            <span v-else>{{ $t('purchasing.accountBalance') }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ agentAccountObj.voucherAccount || 0 }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}</span>
            <span>{{ $t('purchasing.maxDeductible') }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ maxPayMoney || 0 }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}</span>
          </el-form-item>
          <el-form-item v-if="!isUsLocale && isOnline && payData.isPromotePay" :label="$t('purchasing.promoteAccount') + '：'">
            <el-input v-model="formLabelAlign.promoteMoney" @blur="countInputNum(6)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{ $t('purchasing.accountBalance') }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ agentAccountObj.promoteAccount || 0 }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}</span>
          </el-form-item>
          <el-form-item v-if="!isUsLocale" :label="$t('purchasing.goldAccount') + '：'">
            <el-input v-model="formLabelAlign.totalGoldPayMoney" @blur="countInputNum(4)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{ accountLabel }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ agentAccountObj.goldAccount || 0 }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}</span>
            <!-- <span>可用金额：{{ agentAccountObj.halfGoldAmount || 0 }}</span> -->
          </el-form-item>
          <el-form-item v-if="showCashAccountRow" :label="$t('purchasing.cashAccount') + '：'">
            <el-input v-model="formLabelAlign.accountPayMoney" @blur="countInputNum(2)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{ accountLabel }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ agentAccountObj.account || 0 }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}</span>
          </el-form-item>
          <el-form-item v-if="showDelivery && !isUsLocale" :label="$t('purchasing.deliveryVoucherAccount') + '：'">
            <el-input v-model="formLabelAlign.deliveryMoney" @blur="countInputNum(5)"
              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <span>{{ $t('purchasing.accountBalance') }}：{{ isUsLocale ? $crmCurrencySymbol() : '' }}{{ agentAccountObj.deliveryAccount || 0 }}{{ isUsLocale ? '' : $crmCurrencySuffix() }}</span>
          </el-form-item>
          <el-form-item v-if="!isDoubleOrder" :label="$t('purchasing.remainingAmount') + '：'">
            <el-input v-model="formLabelAlign.elsePayMoney" @blur="handleElsePayBlur"></el-input>
          </el-form-item>
          <!-- 与上方表单项共用 label-width，标签与「现金账户」等对齐；内容区与输入框左缘对齐 -->
          <el-form-item
            v-if="bottomShow"
            class="payment-method-row"
            :label="$t('purchasing.paymentMethod') + ($i18n.locale === 'en-US' ? ':' : '：')"
          >
            <div class="payway-row">
              <!-- 美版仅支持对公转账，不提供支付宝/微信 -->
              <template v-if="!isUsLocale">
                <div @click="choicePayWay('mixue_alipay_code')" class="payway-item">
                  <img src="@/assets/images/procure2Pay/zhifubao2.png" alt="" />
                  <div v-if="payType == 'mixue_alipay_code'" class="is-choice-payway"></div>
                </div>
                <div @click="choicePayWay('mixue_wechat_code')" class="payway-item">
                  <img src="@/assets/images/procure2Pay/weixinzhifu1.png" alt="" />
                  <div v-if="payType == 'mixue_wechat_code'" class="is-choice-payway"></div>
                </div>
              </template>
              <div v-if="!isCallCenter" @click="choicePayWay('bank')" class="payway-item">
                <img v-if="!isUsLocale" class="yin" src="@/assets/images/procure2Pay/transfer.jpg" alt="" />
                <span>{{ $t('purchasing.corporateTransfer') }}</span>
                <div v-if="payType == 'bank'" class="is-choice-payway"></div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelPay">{{ $t('purchasing.cancel') }}</el-button>
      <el-button type="primary" @click="Procure2PayFn">{{ $t('purchasing.pay') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  queryAgentAccount,
  queryDualAgentAccount,
  queryMaxVoucherPrice,
  queryMaxCreditVoucherPrice,
  queryDualMaxVoucherPrice,
  queryOrderPayInfo
} from "@/api/AccountInterface";
export default {
  data() {
    return {
      formLabelAlign: {
        voucherAccountPayMoney: 0.0,
        promoteMoney: 0.0,
        totalGoldPayMoney: 0.0,
        accountPayMoney: 0.0,
        deliveryMoney: 0.0,
        elsePayMoney: 0.0
      },
      maxPayMoney: 0,
      agentAccountObj: {},
      payType: "", // 选中的支付方式
      account: 0,
      payWay: 6070001,
      maxPayMoney: 0, //裂变账户最大可支付数
      voucherAccountPayMoney: 0, //裂变账户付款数
      accountPayMoney: 0, //代理商账户付款数
      elsePayMoney: 0, //剩余需要付款数
      deliveryMoney: 0,
      deliveryAccount: 0,
      promoteAccount: 0,
      totalGoldPayMoney: 0,
      totalGoldAccount: 0,
      halfGoldAmount: 0,
      goldAccount: 0,
      procureVoucherAccount: 0,
      isDialogVisiblePay: false,
      payData: {}
    };
  },
  props: {
    orderNo: {
      type: Number | String,
      default: ""
    },
    dialogVisiblePay: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: String,
      default: ""
    },
    bottomShow: {
      default: true
    },
    campusId: {
      type: Number | String,
      default: ""
    },
    dualCampusName:  {
      type: String,
      default: ""
    },
  },
  computed: {
    // 是否是外呼订单
    isCallCenter() {
      return this.orderType == 'callCenter';
    },
    // 是否是双重订单
    isDoubleOrder() {
      return this.orderType == 'doubleOrder';
    },
    // 是否是线上订单
    isOnline() {
      return this.orderType == 'online';
    },
    // 是否是赊货订单
    isCreditOrders() {
      return this.orderType == 'creditorders';
    },
    // 是否显示运费
    showFreight() {
      return this.isDoubleOrder || this.isOnline || this.isCallCenter;
    },
    // 采购量单位
    unitLabel() {
      return this.isCallCenter ? this.$t('purchasing.unitPiece') : this.$t('purchasing.units');
    },
    // 金账户/现金账户标签文本
    accountLabel() {
      return this.isDoubleOrder ? this.$t('purchasing.relatedAgentAccountBalance') : this.$t('purchasing.accountBalance');
    },
    // 是否显示提货券
    showDelivery() {
      return !this.isDoubleOrder && !this.isCreditOrders && this.payData.isDeliveryPay && !this.isCallCenter;
    },
    // 运费金额
    freightAmountDisplay() {
      return this.payData.freightAmount ? this.payData.freightAmount : 0;
    },
    /** 美版 en-US：支付方式与可抵扣账户与国内版拆分 */
    isUsLocale() {
      return this.$i18n.locale === "en-US";
    },
    /**
     * 美版仅当现金账户有余额时展示该行；国内版始终展示（与原行为一致）
     */
    showCashAccountRow() {
      if (!this.isUsLocale) return true;
      return Number(this.agentAccountObj.account || 0) > 0;
    }
  },
  watch: {
    /** 唯一入口：首屏用 immediate 拉一次，换单时随 orderNo 再拉，避免与 mounted 重复 */
    orderNo: {
      handler() {
        this.loadOrderAndAccount();
      },
      immediate: true
    },
    dialogVisiblePay: {
      handler(newVal, oldVal) {
        this.isDialogVisiblePay = newVal;
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 美版计算：裂变金可抵扣 + 现金账户 + 剩余待付；不参与金/提货券/推广（与模板隐藏项一致）。
     * 裂变金额：同国内 default/ case1，取 min(输入/接口值, maxPayMoney, 待付总差额)。
     * 待付在裂变后：remaining = orderAmount - receivedAmount - vPay；现金与剩余拆分同原美版。
     * type 2 / 3 含裂变后的 remaining。
     */
    applyUsPayCalculation(type) {
      const payData = this.payData || {};
      const orderAmount = Number(payData.orderAmount) || 0;
      const receivedAmount = Number(payData.receivedAmount) || 0;
      const account = Number(this.account) || 0;
      const rawRemaining = Math.max(0, orderAmount - receivedAmount);
      const capV = Number(this.maxPayMoney) || 0;
      let vPay;
      if (type === 1) {
        const req = Number(this.formLabelAlign.voucherAccountPayMoney) || 0;
        vPay = Math.max(0, Math.min(req, capV, rawRemaining));
      } else if (type === 2 || type === 3) {
        vPay = Math.max(
          0,
          Math.min(Number(this.formLabelAlign.voucherAccountPayMoney) || 0, capV, rawRemaining)
        );
      } else {
        vPay = Math.max(0, Math.min(capV, rawRemaining));
      }
      this.formLabelAlign.voucherAccountPayMoney = vPay > 0 ? vPay.toFixed(2) : 0;
      this.formLabelAlign.promoteMoney = 0;
      this.formLabelAlign.totalGoldPayMoney = 0;
      this.formLabelAlign.deliveryMoney = 0;

      const remainingOrder = Math.max(0, rawRemaining - vPay);
      let accountPayMoney = Number(this.formLabelAlign.accountPayMoney) || 0;
      let elsePayMoney = Number(this.formLabelAlign.elsePayMoney) || 0;

      if (type === 2) {
        const maxCash = Math.min(account, remainingOrder);
        accountPayMoney = Math.max(0, Math.min(accountPayMoney, maxCash));
        elsePayMoney = Math.max(0, remainingOrder - accountPayMoney);
      } else if (type === 3) {
        const maxElse = remainingOrder;
        elsePayMoney = Math.max(0, Math.min(elsePayMoney, maxElse));
        accountPayMoney = Number(this.formLabelAlign.accountPayMoney) || 0;
      } else {
        const maxCash = Math.min(account, remainingOrder);
        accountPayMoney = maxCash;
        elsePayMoney = Math.max(0, remainingOrder - accountPayMoney);
      }
      this.formLabelAlign.accountPayMoney =
        accountPayMoney > 0 ? accountPayMoney.toFixed(2) : 0;
      this.formLabelAlign.elsePayMoney =
        elsePayMoney > 0 ? elsePayMoney.toFixed(2) : 0;

      if (elsePayMoney <= 0) {
        this.payType = "";
      }
    },
    // 支付
    Procure2PayFn() {
      if (this.formLabelAlign.elsePayMoney > 0 && !this.payType && this.bottomShow) {
        // 需要支付金额的
        this.$message.error(this.$t('purchasing.pleaseSelectPaymentMethod'));
      } else if (this.formLabelAlign.elsePayMoney <= 0) {
        if (
          this.formLabelAlign.voucherAccountPayMoney ||
          this.formLabelAlign.promoteMoney ||
          this.formLabelAlign.accountPayMoney ||
          this.formLabelAlign.totalGoldPayMoney ||
          this.formLabelAlign.deliveryMoney
        ) {
          console.log("走合理111");
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj
          );
        } else {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "submitAndAgentPay"
          );
        }
      } else if (
        this.payType == "bank" &&
        this.formLabelAlign.elsePayMoney > 0
      ) {
        // 对公转账
        console.log("bankRransferPay");
        this.$emit(
          "bankRransferPay",
          this.formLabelAlign,
          this.payType,
          this.agentAccountObj
        );
      } else {
        if (
          this.formLabelAlign.voucherAccountPayMoney ||
          this.formLabelAlign.promoteMoney ||
          this.formLabelAlign.accountPayMoney ||
          this.formLabelAlign.totalGoldPayMoney ||
          this.formLabelAlign.deliveryMoney
        ) {
          console.log("submitPay");
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "submitAndAgentPay"
          );
        } else {
          this.$emit(
            "submitPay",
            this.formLabelAlign,
            this.payType,
            this.agentAccountObj,
            "onlyAgentPay"
          );
        }
      }
    },
    // 处理账户数据
    handleAccountData(data, isDoubleOrder = false) {
      const {
        account,
        voucherAccount,
        maxVoucherPrice,
        halfGoldAmount,
        goldAccount,
        deliveryAccount,
        promoteAccount
      } = data;

      this.account = account || 0;
      this.halfGoldAmount = halfGoldAmount;
      this.totalGoldAccount = halfGoldAmount;
      this.goldAccount = goldAccount;
      this.deliveryAccount = deliveryAccount;
      this.promoteAccount = promoteAccount || 0;

      if (isDoubleOrder) {
        let maxPayMoney =
          voucherAccount > maxVoucherPrice
            ? maxVoucherPrice
            : voucherAccount;
        this.maxPayMoney = maxPayMoney;
      }
    },

    // 处理裂变账户数据
    handleVoucherPriceData(data, isDoubleOrder = false) {
      const { voucherAccount, maxVoucherPrice } = data;
      let maxPayMoney =
        voucherAccount > maxVoucherPrice
          ? maxVoucherPrice
          : voucherAccount;
      this.maxPayMoney = maxPayMoney;
      this.voucherList = data;
      this.formLabelAlign.voucherAccountPayMoney = data.maxVoucherPrice;

      if (isDoubleOrder) {
        this.procureVoucherAccount = voucherAccount;
      }
    },

    // 获取代理商账户信息
    async fetchAgentAccount() {
      const isDoubleOrder = this.orderType == "doubleOrder";
      const queryFn = isDoubleOrder
        ? () => queryDualAgentAccount({ orderNo: this.orderNo })
        : () => queryAgentAccount({ campusId: this.campusId });

      const ret = await queryFn();
      if (ret.code == 0) {
        this.agentAccountObj = ret.data;
        this.handleAccountData(this.agentAccountObj, isDoubleOrder);
      }
    },

    // 获取裂变账户最大可抵扣金额
    async fetchMaxVoucherPrice() {
      if (this.orderType == "online" || this.orderType == "callCenter") {
        const ret = await queryMaxVoucherPrice({ orderNo: this.orderNo });
        if (ret.code === 0) {
          this.handleVoucherPriceData(ret.data, false);
        }
      } else if (this.orderType == "doubleOrder") {
        const ret = await queryDualMaxVoucherPrice({ orderNo: this.orderNo });
        if (ret.code === 0) {
          this.handleVoucherPriceData(ret.data, true);
        }
      } else {
        this.maxPayMoney = 0;
        this.formLabelAlign.voucherAccountPayMoney = 0;
      }
    },

    /**
     * 先拉订单 payData，再拉账户与裂变，最后只调一次 countInputNum，避免与 queryOrderInfo 并发导致先算一次（voucher/剩余错误）再算一次
     */
    async loadOrderAndAccount() {
      if (this.orderNo === undefined || this.orderNo === null || this.orderNo === "") {
        return;
      }
      await this.queryOrderInfo();
      await this.selectData();
    },
    async selectData() {
      await this.fetchAgentAccount();
      await this.fetchMaxVoucherPrice();
      this.countInputNum();
    },
    // 计算推广费（在裂变之后）
    calculatePromoteMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteAccount, isPromotePay }) {
      // 如果不允许使用推广费,则返回0
      if (!isPromotePay) {
        return 0;
      }
      const remainingAfterVoucher = orderAmount * 100 - receivedAmount * 100 - voucherAccountPayMoney1 * 100;
      return promoteAccount * 100 > remainingAfterVoucher
        ? remainingAfterVoucher / 100
        : promoteAccount;
    },

    // 计算金账户（在推广费之后）
    calculateGoldMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldAccount }) {
      const remainingAfterPromote = orderAmount * 100 -
        (receivedAmount * 100 + voucherAccountPayMoney1 * 100 + promoteMoney1 * 100);
      return remainingAfterPromote / 100 > totalGoldAccount
        ? totalGoldAccount
        : remainingAfterPromote / 100;
    },

    // 计算现金账户（在金账户之后）
    calculateAccountMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, account, deliveryMoney1 = 0 }) {
      const deliveryMoneyNum = Number(deliveryMoney1) || 0;
      const remainingAfterGold = orderAmount * 100 -
        receivedAmount * 100 -
        voucherAccountPayMoney1 * 100 -
        promoteMoney1 * 100 -
        totalGoldPayMoney1 * 100 -
        deliveryMoneyNum * 100;
      const required = remainingAfterGold / 100;
      return account > required ? required : account;
    },

    // 计算提货券（在现金账户之后）
    calculateDeliveryMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1, deliveryAccount }) {
      const elsePayMoneyNum = Number(elsePayMoney1) || 0;
      const remainingAfterCash = orderAmount * 100 -
        (receivedAmount * 100 +
          voucherAccountPayMoney1 * 100 +
          promoteMoney1 * 100 +
          totalGoldPayMoney1 * 100 +
          accountPayMoney1 * 100 +
          elsePayMoneyNum * 100);
      const required = remainingAfterCash / 100;
      return deliveryAccount > required ? required : deliveryAccount;
    },

    // 计算剩余金额（在所有账户之后）
    calculateElsePayMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 }) {
      const totalPaid = receivedAmount * 100 +
        voucherAccountPayMoney1 * 100 +
        promoteMoney1 * 100 +
        totalGoldPayMoney1 * 100 +
        accountPayMoney1 * 100 +
        deliveryMoney1 * 100;
      return Math.max(0, (orderAmount * 100 - totalPaid) / 100);
    },

    // 根据type计算各账户金额
    calculateByType(type, context) {
      const {
        voucherAccountPayMoney, promoteMoney, accountPayMoney, elsePayMoney,
        totalGoldPayMoney, deliveryMoney, maxPayMoney, totalGoldAccount,
        account, deliveryAccount, promoteAccount, orderAmount, receivedAmount, payData
      } = context;

      // 判断是否允许使用推广费
      const isPromotePay = payData.isPromotePay;
      const hasDelivery = this.orderType != 'doubleOrder' && this.orderType != 'creditorders' && payData.isDeliveryPay;

      // 声明所有需要使用的变量
      let voucherAccountPayMoney1, promoteMoney1, accountPayMoney1,
          elsePayMoney1, totalGoldPayMoney1, deliveryMoney1;

      switch (type) {
        case 1: // 裂变奖金账户
          voucherAccountPayMoney1 = voucherAccountPayMoney > maxPayMoney ? maxPayMoney : voucherAccountPayMoney;
          promoteMoney1 = this.calculatePromoteMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteAccount, isPromotePay });
          totalGoldPayMoney1 = this.calculateGoldMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldAccount });
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, account });
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 2: // 现金账户
          voucherAccountPayMoney1 = voucherAccountPayMoney;
          totalGoldPayMoney1 = totalGoldPayMoney;
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          const deliveryMoneyNum = Number(deliveryMoney) || 0;
          accountPayMoney1 = accountPayMoney;
          // 确保不超出订单金额
          const remainingForAccount = orderAmount * 100 - receivedAmount * 100 -
            voucherAccountPayMoney1 * 100 - promoteMoney1 * 100 - totalGoldPayMoney1 * 100 - deliveryMoneyNum * 100;
          accountPayMoney1 = Math.min(accountPayMoney1 * 100, remainingForAccount) / 100;
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = deliveryMoneyNum;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 3: // 剩余支付金额
          voucherAccountPayMoney1 = voucherAccountPayMoney;
          totalGoldPayMoney1 = totalGoldPayMoney;
          accountPayMoney1 = accountPayMoney;
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          elsePayMoney1 = elsePayMoney;
          deliveryMoney1 = hasDelivery ? deliveryMoney : 0;
          break;

        case 4: // 金账户
          voucherAccountPayMoney1 = voucherAccountPayMoney;
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          const deliveryMoneyNum4 = Number(deliveryMoney) || 0;
          totalGoldPayMoney1 = totalGoldPayMoney;
          // 确保不超出订单金额
          const remainingForGold = orderAmount - receivedAmount - voucherAccountPayMoney1 - promoteMoney1 - deliveryMoneyNum4;
          totalGoldPayMoney1 = totalGoldPayMoney1 > remainingForGold ? remainingForGold : totalGoldPayMoney1;
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, account });
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 5: // 提货券
          voucherAccountPayMoney1 = voucherAccountPayMoney;
          promoteMoney1 = isPromotePay ? promoteMoney || 0 : 0;
          const deliveryMoneyNum5 = Number(deliveryMoney) || 0;
          totalGoldPayMoney1 = totalGoldPayMoney;
          const remainingForGold5 = orderAmount - receivedAmount - voucherAccountPayMoney1 - promoteMoney1 - deliveryMoneyNum5;
          totalGoldPayMoney1 = totalGoldPayMoney1 > remainingForGold5 ? remainingForGold5 : totalGoldPayMoney1;
          accountPayMoney1 = accountPayMoney;
          const remainingForAccount5 = orderAmount - receivedAmount - voucherAccountPayMoney1 - promoteMoney1 - totalGoldPayMoney1 - deliveryMoneyNum5;
          accountPayMoney1 = accountPayMoney1 > remainingForAccount5 ? remainingForAccount5 : accountPayMoney1;
          if (totalGoldPayMoney1 < 0) totalGoldPayMoney1 = 0;
          if (accountPayMoney1 < 0) accountPayMoney1 = 0;
          if (hasDelivery) {
            const remainingAfterOthers = orderAmount * 100 - receivedAmount * 100 -
              voucherAccountPayMoney * 100 - promoteMoney1 * 100 - totalGoldPayMoney1 * 100 - accountPayMoney1 * 100;
            deliveryMoney1 = deliveryMoneyNum5 * 100 > remainingAfterOthers ? remainingAfterOthers / 100 : deliveryMoneyNum5;
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        case 6: // 推广费账户
          voucherAccountPayMoney1 = voucherAccountPayMoney;
          // 如果不允许使用推广费，直接设置为0
          if (!isPromotePay) {
            promoteMoney1 = 0;
          } else {
            // 推广费金额不能大于账户余额，也不能大于剩余待支付金额
            const remainingAfterVoucher = orderAmount * 100 - receivedAmount * 100 - voucherAccountPayMoney1 * 100;
            promoteMoney1 = promoteMoney * 100 > promoteAccount * 100
              ? (promoteAccount * 100 > remainingAfterVoucher ? remainingAfterVoucher : promoteAccount * 100) / 100
              : (promoteMoney * 100 > remainingAfterVoucher ? remainingAfterVoucher : promoteMoney * 100) / 100;
          }
          totalGoldPayMoney1 = this.calculateGoldMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldAccount });
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, account });
          if (hasDelivery) {
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: 0, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;

        default: // 初始化计算
          voucherAccountPayMoney1 = maxPayMoney > orderAmount - receivedAmount ? orderAmount - receivedAmount : maxPayMoney;
          const remainingAfterVoucherDef = orderAmount * 100 - receivedAmount * 100 - voucherAccountPayMoney1 * 100;
          promoteMoney1 = isPromotePay ? Math.min((promoteAccount || 0) * 100, remainingAfterVoucherDef) / 100 : 0;
          if (promoteMoney1 < 0) promoteMoney1 = 0;
          totalGoldPayMoney1 = this.calculateGoldMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldAccount });
          if (totalGoldPayMoney1 < 0) totalGoldPayMoney1 = 0;
          const deliveryMoneyNumDef = Number(deliveryMoney) || 0;
          accountPayMoney1 = this.calculateAccountMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, account, deliveryMoney1: deliveryMoneyNumDef });
          if (hasDelivery) {
            const elsePayMoneyNumDef = Number(elsePayMoney) || 0;
            deliveryMoney1 = this.calculateDeliveryMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, elsePayMoney1: elsePayMoneyNumDef, deliveryAccount });
          } else {
            deliveryMoney1 = 0;
          }
          elsePayMoney1 = this.calculateElsePayMoney({ orderAmount, receivedAmount, voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1 });
          break;
      }

      return { voucherAccountPayMoney1, promoteMoney1, totalGoldPayMoney1, accountPayMoney1, deliveryMoney1, elsePayMoney1 };
    },
    /**
     * 计算输入金额的数量
     * @param {string} type - 支付类型
     */
    countInputNum(type) {
      if (this.isUsLocale) {
        this.applyUsPayCalculation(type);
        return;
      }
      const payData = this.payData;
      const { account, maxPayMoney, totalGoldAccount, deliveryAccount, promoteAccount } = this;
      const {
        voucherAccountPayMoney, promoteMoney, accountPayMoney, elsePayMoney,
        totalGoldPayMoney, deliveryMoney
      } = this.formLabelAlign;
      const { orderAmount, receivedAmount } = this.payData;

      // 金账户金额不能大于账户余额
      const goldMoneyLimited = Number(totalGoldPayMoney) > totalGoldAccount
        ? totalGoldAccount
        : Number(totalGoldPayMoney);
      if (goldMoneyLimited !== Number(totalGoldPayMoney)) {
        this.formLabelAlign.totalGoldPayMoney = goldMoneyLimited > 0 ? goldMoneyLimited.toFixed(2) : 0;
      }

      // 提货券金额不能大于账户余额
      const deliveryMoneyLimited = Number(deliveryMoney) > deliveryAccount
        ? deliveryAccount
        : Number(deliveryMoney);
      if (deliveryMoneyLimited !== Number(deliveryMoney)) {
        this.formLabelAlign.deliveryMoney = deliveryMoneyLimited > 0 ? deliveryMoneyLimited.toFixed(2) : 0;
      }

      const context = {
        voucherAccountPayMoney, promoteMoney, accountPayMoney, elsePayMoney,
        totalGoldPayMoney: goldMoneyLimited, deliveryMoney: deliveryMoneyLimited, maxPayMoney, totalGoldAccount,
        account, deliveryAccount, promoteAccount, orderAmount, receivedAmount, payData
      };

      const result = this.calculateByType(type, context);

      // 更新表单数据
      const voucherNum = Number(result.voucherAccountPayMoney1) || 0;
      const accountNum = Number(result.accountPayMoney1) || 0;
      const elseNum = Number(result.elsePayMoney1) || 0;
      const goldNum = Number(result.totalGoldPayMoney1) || 0;
      const deliveryNum = Number(result.deliveryMoney1) || 0;
      const promoteNum = Number(result.promoteMoney1) || 0;

      this.formLabelAlign.voucherAccountPayMoney =
        voucherNum > 0 ? voucherNum.toFixed(2) : 0;
      this.formLabelAlign.accountPayMoney =
        accountNum > 0 ? accountNum.toFixed(2) : 0;
      this.formLabelAlign.elsePayMoney =
        elseNum > 0 ? elseNum.toFixed(2) : 0;
      this.formLabelAlign.totalGoldPayMoney =
        goldNum > 0 ? goldNum.toFixed(2) : 0;
      this.formLabelAlign.deliveryMoney =
        deliveryNum > 0 ? deliveryNum.toFixed(2) : 0;
      this.formLabelAlign.promoteMoney =
        promoteNum > 0 ? promoteNum.toFixed(2) : 0;
    },
    /** 美版：改「剩余支付金额」时与国内版 case 3 一致，只约束剩余金额，不改变现金账户 */
    handleElsePayBlur() {
      if (this.isUsLocale) {
        this.countInputNum(3);
      }
    },
    // 选中支付方式
    choicePayWay(way) {
      this.payType = way;
    },
    // 取消支付
    cancelPay() {
      // if (this.formLabelAlign.voucherAccountPayMoney || this.formLabelAlign.accountPayMoney || this.formLabelAlign.totalGoldPayMoney || this.formLabelAlign.deliveryMoney) {
      //   this.$emit('submitPay', this.formLabelAlign, this.payType, this.agentAccountObj, 'paymentFN');
      // } else {
      //   this.$emit('cancelSubitPay');
      // }
      this.$emit("cancelSubitPay");
    },
    closeProcure2Pay() {
      this.isDialogVisiblePay = false;
      this.payType = "";
      this.$emit("closeProcure2Pay");
    },
    async queryOrderInfo() {
      if (this.orderNo === undefined || this.orderNo === null || this.orderNo === "") {
        return;
      }
      const ret = await queryOrderPayInfo({ orderNo: this.orderNo });
      if (ret.code === 0) {
        this.payData = ret.data;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-info {
  color: #4A83E8;
  background: rgb(232, 243, 254);
  width: 95%;
  height: 80px;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  padding: 10px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.pay-box {
  margin-left: 20px;

  .el-input {
    text-align: left;
    width: 40%;
    margin-right: 8%;
  }

  &.pay-box-en .el-input {
    width: 26%;
    margin-right: 2%;
  }

  &.pay-box-en .payway-item {
    width: 215px;
  }

  span {
    margin-right: 3%;
  }

  .payment-method-row {
    margin-bottom: 0;
    :deep(.el-form-item__label) {
      line-height: 52px;
    }
    :deep(.el-form-item__content) {
      line-height: 52px;
    }
  }

  .payway-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 16px;
  }

  .payway-item {
    position: relative;
    width: 145px;
    height: 52px;
    flex-shrink: 0;
    border: 1px solid rgb(103, 99, 99);
    border-radius: 5px;
    line-height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 117px;
      height: 40px;
    }

    .yin {
      width: 54px;
      height: 34px;
    }

    &:hover {
      cursor: pointer;
    }

    .is-choice-payway {
      position: absolute;
      width: 23px;
      height: 23px;
      background: url("@/assets/images/procure2Pay/cornerMark.png") no-repeat;
      right: 0;
      bottom: 0;
      background-size: 100% 100%;
    }
  }
}

:deep(.el-dialog__footer) {
  border-top: 1px solid #e8e8e8;
  padding: 10px;
}
</style>
